<template>
  <div class="layout text-white h-full bg-bg-1 flex schedule-plan flex-col px-32 py-20">
    <ProgramEdit
      v-model:visible="showProgramModal"
      :team-id="teamId"
      :program-info="program2edit"
      @on-save="handleSaveProgram"
      @on-cancel="handleProgramModalChange"
      :operate-type="operateType"
      :readonly="true"
      :closable="false"
      from="workout"
    >
      <template v-slot:footerBtn="slotProps">
        <div v-if="!isMySelf">
          <Button
            @click="importProgram(slotProps)"
            type="primary"
            :loading="loading"
            >{{ $t('R1110') }}</Button
          >
        </div>
      </template>
    </ProgramEdit>
  </div>
</template>
<script setup>
import { ref, computed, onBeforeMount } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { cloneDeep } from 'lodash';
import { userStore as userStoreRef } from '@client/store/userStore';
import { scheduleStore as scheduleStoreRef } from '@client/store/scheduleStore';
import { initStore as initStoreRef } from '@client/store/initStore';
import { Button, Modal, Message } from '@arco-design/web-vue';
import ProgramEdit from '@client/components/programEdit/index.vue';
import { dealSavingData } from '@client/components/programEdit/utils';
import { training } from '@client/api';
import { getBaseConfigByRegion } from '@client/helper/http';
const route = useRoute();
const { t } = useI18n();
const initStore = initStoreRef();
const userStore = userStoreRef();
const scheduleStore = scheduleStoreRef();
const isMySelf = computed(() => {
  return userStore.userId === program2edit.value.userId;
});
const showProgramModal = ref(false);
const loading = ref(false);
const teamId = ref('');
const program2edit = ref({});
const operateType = ref('share');
initStore.getPublicProfile();
const { programId, region, redirect } = route.query;
onBeforeMount(async () => {
  // 如果跨服, 则重定向至当前cookie 对应地区
  if (initStore.CPL_Region && region != initStore.CPL_Region && redirect !== '1') {
    // 跨服, 查询cookie 对应信息
    const { hostname, teamapi } = getBaseConfigByRegion(initStore.CPL_Region);
    // 重定向走
    window.location.href = `${hostname}/workout-program?programId=${programId}&region=${region}&redirect=1`;
  } else {
    await getUser();
  }
});

const getProgramDetail = () => {
  scheduleStore
    .fetchProgramDetail({
      id: programId,
      region,
      supportRestExercise: 1
    })
    .then((res) => {
      program2edit.value = res;
      showProgramModal.value = true;
    });
};
const getUser = async () => {
  if (initStore.CPL_Token && initStore.CPL_Region) {
    const { teamapi } = getBaseConfigByRegion(initStore.CPL_Region);
    await userStore.initUserInfo({
      baseURL: teamapi
    });
  }

  if (programId) {
    // 请求详情
    getProgramDetail();
  }
};

const importProgram = async ({ formData }) => {
  if (loading.value) return;
  const { CPL_Token, CPL_Region } = initStore;
  if (!CPL_Token) {
    Modal.confirm({
      title: t(`R9008`),
      okText: t(`C1005`),
      cancelText: t(`C1006`),
      titleAlign: 'start',
      modalClass: 'coros-modal-footer-right',
      onOk: () => {
        // 移除temp_token
        const lastUrl = route.fullPath.replace(/&temp_token=.+(&)?/, '$1');

        window.location.href = `/login?lastUrl=${encodeURIComponent(lastUrl)}`;
      }
    });
    return;
  }

  loading.value = true;
  const { id } = program2edit.value;
  const { regionId: region } = initStore;
  const { trainingProgram, currentZoneData, exercises, sportConfig, currentUnit, currentCriticalPower } = formData;
  // 补全数据缺失
  const data = dealSavingData(cloneDeep(trainingProgram), currentZoneData, exercises, sportConfig, currentUnit, currentCriticalPower);

  try {
    const mathInfo = await calculateProgram(data);

    const { planDistance: distance, planDuration: duration, planTrainingLoad: trainingLoad, planSets: sets } = mathInfo.value;
    data.distance = distance;
    data.duration = duration;
    data.trainingLoad = trainingLoad;
    data.sets = sets;
  } catch (err) {
    Message.error('error');
  }
  const { name, overview, sportType } = trainingProgram;

  data.exercises.forEach((exercise) => {
    exercise.name = exercise.name || '';
    exercise.overview = exercise.overview || overview;
    exercise.sportType = sportType;
    exercise.programId = id;
  });
  const { teamapi, hostname } = getBaseConfigByRegion(CPL_Region);
  training
    .api4copyTrainingProgram2currentUser({
      baseURL: teamapi,
      params: {
        id,
        region
      },
      data
    })
    .then(({ data }) => {
      loading.value = false;
      program2edit.value = data.value;
      Message.success({
        content: t(`R9006`),
        onClose: () => {
          // 跳转至个人
          const { id: p_id } = data.value;
          window.location.href = `${hostname}/workout-program?programId=${p_id}&region=${CPL_Region}&redirect=1`;
        }
      });
    })
    .catch((err) => {
      console.log(err);
      loading.value = false;
    });
};
// 调用接口计算program的数值
const calculateProgram = async (program) => {
  return new Promise((resolve, reject) => {
    training
      .api4CalculateTrainingProgram({
        data: program
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
const handleProgramModalChange = () => {};
</script>
<style lang="scss">
@import '@client/styles/_mixins.scss';
</style>
